import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import validator from 'services/validator';
import email from 'services/email';

import InputField from 'components/InputField';
import TitleWithShape from 'components/TitleWithShape';
import IconButton from 'components/IconButton';
import HelpText from 'components/HelpText';

const Wrapper = styled.div`
  .title-wrapper {
    margin: 6.8rem 35rem 7.1rem 16rem;
  }
  .content {
    display: flex;
    justify-content: center;
    padding-left: 5.4rem;
    padding-right: 5.4rem;
    margin-top: 7.1rem;
    .form-wrapper {
      background: #f8f7f3;
      width: 66rem;
      padding-bottom: 6rem;
      .bar-wrapper {
        display: flex;
        justify-content: flex-start;
        padding-top: 3rem;
        padding-right: 3.7rem;

        button {
          background-color: inherit;
          border: none;
          color: #35447c;
          cursor: pointer;
          font-size: 1.6rem;
          margin-left: 2.2rem;
          margin-right: auto;
          text-decoration: underline;
        }
      }
      .form-title {
        margin-top: 6.2rem;
        margin-left: 10.3rem;
      }
      .fields {
        margin-top: 6rem;
        margin-left: auto;
        margin-right: auto;
        width: 45.5rem;
        .button-wrapper {
          margin-top: 4rem;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
    .info-wrapper {
      margin-top: 6rem;
      width: 36rem;
      margin-left: 12rem;
    }
  }

  @media only screen and (max-width: 1100px) {
    .title-wrapper {
      margin: 4rem 6rem;
    }
    .content {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      margin: 0;
      padding: 0;
      .info-wrapper {
        margin-top: 1rem;
        margin-bottom: 2rem;
        margin-left: 0;
      }
    }
  }
`;

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = props.formData;
    this.state.redirect = false;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChange = (e, key) => {
    this.setState({ [key]: e.target.value });
  }

  nextFormPage() {
    if (!this.validate()) { return; }
    if (!this.state.emailSent) {
      this.setState({ submitted: true });
      // Send lead email
      email.lead(this.state, this.props.forWho);
      fetch(`${process.env.REACT_APP_API_ENDPOINT}/email`, {
        method: 'POST',
        body: JSON.stringify(email),
      }).then((res) => {
        if (res.ok) {
          this.setState(
            {
              completed: true,
              emailSent: true,
              submitted: false,
            },
            () => {
              this.props.collectData('step1', this.state);
              this.setState({ redirect: '/get-started/step-two' });
            },
          );
        }
      });
    } else {
      this.setState({ completed: true }, () => {
        this.props.collectData('step1', this.state);
        this.setState({ redirect: '/get-started/step-two' });
      });
    }
  }

  validate() {
    const toBeValidated = ['name', 'email', 'phone'];
    if (this.props.forWho === 'other') {
      ['whoseBehalf', 'relationshipWithPerson'].forEach(key => toBeValidated.push(key));
    }
    const newState = validator.validate(this.state, toBeValidated);
    this.setState(newState);
    return newState.isValid;
  }

  render() {
    const { redirect } = this.state;

    if (redirect) {
      return <Redirect to={redirect} push />;
    }

    return (
      <Wrapper>
        <div className="title-wrapper">
          <TitleWithShape
            title={
              <div><span>Before you begin</span> make sure you have digital copies of all
                documentation relevant to your question.
              </div>}
            subTitle={
              <div>This could include Court documents, correspondence, agreements, leases,<br />
                demands, invoices, or any other relevant documents.
              </div>}
          />
        </div>
        <div className="content">
          <div className="form-wrapper">
            <div className="bar-wrapper">
              <button onClick={() => this.props.startOver()}>Start over</button>
            </div>
            <div className="form-title">
              <TitleWithShape
                title="Contact info"
              />
            </div>
            <div className="fields">
              <InputField placeholder="Name" value={this.state.name} name="name" onChange={this.onChange} error={this.state.nameError} isRequired />
              <InputField placeholder="Email" value={this.state.email} name="email" onChange={this.onChange} error={this.state.emailError} isRequired />
              <InputField placeholder="Phone" value={this.state.phone} name="phone" onChange={this.onChange} error={this.state.phoneError} isRequired />
              {this.props.forWho === 'other' && (
                <div>
                  <InputField placeholder="Person/entity on whose behalf you are asking a question" value={this.state.whoseBehalf} name="whoseBehalf" onChange={this.onChange} error={this.state.whoseBehalfError} isRequired textarea />
                  <InputField placeholder="Your role/relationship with the above identified person/entity" value={this.state.relationshipWithPerson} name="relationshipWithPerson" onChange={this.onChange} error={this.state.relationshipWithPersonError} isRequired textarea />
                </div>
              )}
              <div className="button-wrapper">
                <IconButton
                  name="Save and continue"
                  icon="downArrow"
                  onClick={() => this.nextFormPage()}
                  selected
                  noBorder
                  loading={this.state.submitted}
                  disabled={this.state.submitted}
                />
              </div>
            </div>
          </div>
          <div className="info-wrapper">
            <HelpText>Please enter your relevant personal information.</HelpText>
          </div>
        </div>
      </Wrapper>
    );
  }
}

Step1.propTypes = {
  collectData: PropTypes.func.isRequired,
  formData: PropTypes.objectOf(PropTypes.object).isRequired,
  forWho: PropTypes.string.isRequired,
  startOver: PropTypes.func.isRequired,
};

export default Step1;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step1.js